import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative pt-12 pb-20 md:pt-20 md:pb-32 overflow-hidden bg-stadium-glow" data-id="element-79">
      <div className="container mx-auto px-4 relative z-10" data-id="element-80">
        <div className="max-w-5xl mx-auto text-center" data-id="element-81">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-82">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-navy-800/80 border border-gold-500/30 text-gold-400 font-oswald uppercase tracking-widest text-sm mb-6 backdrop-blur-sm" data-id="element-83">
              <span className="w-2 h-2 rounded-full bg-gold-500 animate-pulse" data-id="element-84"></span>
              PROVEN COACHING SYSTEM
            </div>

            <h1 className="font-anton text-5xl md:text-7xl lg:text-8xl text-white uppercase tracking-wide leading-[1.1] mb-6 drop-shadow-2xl" data-id="element-85">
              The Complete Season Planning System For{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold-400 to-gold-600" data-id="element-86">
                Basketball Coaches
              </span>
            </h1>

            <p className="text-lg md:text-2xl text-gray-300 max-w-3xl mx-auto mb-10 font-medium leading-relaxed" data-id="element-87">
              Save time, reduce stress, and develop better players — without
              spending hours planning training sessions from scratch.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative mb-12 group" data-id="element-88">
            <div className="absolute -inset-4 bg-gradient-to-r from-gold-500/20 via-gold-600/20 to-gold-500/20 rounded-2xl blur-2xl opacity-50 group-hover:opacity-70 transition-opacity duration-500" data-id="element-89"></div>
            <img src="https://cdn.magicpatterns.com/uploads/vF1P8TNmaRQc6eH9i9F9uw/ChatGPT_Image_19_jun_2026,_01_16_23.webp" alt="Basketball Ready System 365 - 6 Volumes + 5 Bonuses" width={1536} height={1024} loading="eager" fetchPriority="high" decoding="async" className="relative w-full h-auto rounded-xl shadow-2xl border border-navy-700/50" data-id="element-90" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="flex flex-col items-center gap-6" data-id="element-91">
            <Button size="xl" onClick={() => document.getElementById('offer')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-92">
              YES, I WANT MY SYSTEM NOW
            </Button>

            <div className="flex flex-col items-center gap-3" data-id="element-93">
              <div className="flex items-center gap-1" data-id="element-94">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold-500 text-gold-500" data-id="element-95" />)}
                <span className="ml-2 font-oswald text-lg text-gray-200" data-id="element-96">
                  4.9/5 — Verified Reviews
                </span>
              </div>

              <div className="flex items-center gap-2 text-gray-400 text-sm font-medium" data-id="element-97">
                <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-98" />
                <span data-id="element-99">7-Day Money Back Guarantee — Zero Risk</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}